import { fetchConToken, fetchSinToken } from "../utils/fetch.ts";


export const doLogin = async (email:string, password:string) => {
  try {
    const resp = await fetchSinToken("auth/login", { email, password }, "POST");
    const body = await resp.json();
    return body;

  } catch (error) {
    return {};
  }
};


export const renewToken = async () => {
  try {
    const resp = await fetchConToken("auth/renew-token");
    const body = await resp.json();
    return body;

  } catch (error) {
    return {};
  }
};


export const resetPasswordSendCode = async (email:string) => {
  try {
    const resp = await fetchSinToken("auth/reset-password-send-code", { email }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return {};
  }
};


export const resetPasswordCheckUUID = async ( uuid:string ) => {
  try {
    const resp = await fetchSinToken("auth/reset-password-check-uuid", { uuid }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return {};
  }
}


export const resetPasswordCheckCode = async (uuid:string, verificationCode:string) => {
  try {
    const resp = await fetchSinToken("auth/reset-password-check-code", { uuid, verificationCode }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return {};
  }
};


export const resetPasswordConfirm = async ( uuid:string, password1:string, password2:string ) => {
  try {
    const resp = await fetchSinToken("auth/reset-password-confirm", { uuid, password1, password2 }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return {};
  }
}

